import { request } from './auth-actions'
import { genericError } from './action-utils'
import paymentEngineApi from '../../api/payment-engine-api'
import { notify } from './notification-actions'
import { NOTIFY_SUCCESS } from './action-types'
import { getText } from '../../internal/TextLabels'

const performRequestAndHandleResponse =
  (
    apiFunctionality,
    successfulAction = () => {},
    unsuccessfulAction = () => {},
  ) =>
  dispatch =>
    dispatch(request(apiFunctionality))
      .then(response => successfulAction(response))
      .catch(error => {
        unsuccessfulAction(error)
        genericError(error)
        throw error
      })

export const resendSigning =
  (
    { paymentId, customer = {}, coCustomer = {} },
    successfulResponse,
    unsuccessfulResponse,
  ) =>
  dispatch =>
    dispatch(
      performRequestAndHandleResponse(
        paymentEngineApi.payment.resendSigning(paymentId, customer, coCustomer),
        successfulResponse,
        unsuccessfulResponse,
      ),
    ).then(() => {
      notify(NOTIFY_SUCCESS, getText('ongoingPayments.resendNotification'))
    })

export const requestSigningForOngoingPayment =
  (
    {
      paymentId,
      forceElectronicSigning = true,
      useDigitalAgreement = false,
      customer,
      coCustomer = {},
      delayedPayment = true,
      automaticDebitDate = null,
    },
    successfulResponse,
    unsuccessfulResponse,
  ) =>
  dispatch =>
    dispatch(
      performRequestAndHandleResponse(
        paymentEngineApi.payment.prepareForRedirection(
          paymentId,
          forceElectronicSigning,
          useDigitalAgreement,
          { customer, coCustomer },
          delayedPayment,
          automaticDebitDate,
        ),
        successfulResponse,
        unsuccessfulResponse,
      ),
    )
